//@flow

import "./src/styles/index.scss";

import React from "react";
import { Provider } from "react-redux";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import { create } from "./src/redux";
import theme from "./src/styles/theme";

const store = create();

export const wrapRootElement = ({ element }: *) => (
    <Provider store={store}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>{element}</ThemeProvider>
        </StyledEngineProvider>
    </Provider>
);
